module.exports = __webpack_public_path__ + "static/media/syria.9c95b312.svg";